import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * /embed/stats/:username
 * A minimal, iframe-ready stats card. Streamers and creators can embed it.
 * No navbar, no footer — just the card.
 */
export default function EmbedStats() {
  const { username } = useParams();
  const [data, setData]     = useState(null);
  const [error, setError]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!username) return;
    const decoded = decodeURIComponent(username);

    // Try Apex first, then Fortnite
    fetch(`${API}/user/${encodeURIComponent(decoded)}`)
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(d => { setData(d); setLoading(false); })
      .catch(() => {
        fetch(`${API}/user/fortnite/${encodeURIComponent(decoded)}`)
          .then(r => r.ok ? r.json() : Promise.reject(r))
          .then(d => { setData(d); setLoading(false); })
          .catch(() => { setError('Player not found'); setLoading(false); });
      });
  }, [username]);

  const cardStyle = {
    maxWidth: 360,
    margin: '0 auto',
    padding: 20,
    background: '#0a0a0f',
    border: '1px solid #ffffff15',
    borderRadius: 14,
    color: '#fff',
    fontFamily: "'Inter', system-ui, sans-serif",
    fontSize: 14,
  };
  const gradientText = {
    background: 'linear-gradient(135deg, #00D4FF 0%, #8B00FF 100%)',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    color: 'transparent',
  };
  const statBox = {
    display: 'inline-block',
    minWidth: 70,
    textAlign: 'center',
    marginRight: 16,
  };

  if (loading) return <div style={{ ...cardStyle, textAlign: 'center', color: '#ffffff88' }}>Loading...</div>;
  if (error)   return <div style={{ ...cardStyle, textAlign: 'center', color: '#FF006E' }}>{error}</div>;

  const { user, tournaments } = data;
  const handle = user.epic_player_id || user.apex_player_id || '—';
  const wins   = tournaments.filter(t => t.won).length;
  const total  = tournaments.length;
  const winRate = total ? Math.round((wins / total) * 100) : 0;

  return (
    <div style={{ padding: 8, background: 'transparent', minHeight: '100vh' }}>
      <div style={cardStyle}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', color: '#ffffff66', marginBottom: 8 }}>
          EZGAME Stats
        </div>
        <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 14, ...gradientText }}>
          {handle}
        </div>
        <div>
          <div style={statBox}>
            <div style={{ fontSize: 22, fontWeight: 800 }}>{total}</div>
            <div style={{ fontSize: 11, color: '#ffffff88' }}>Played</div>
          </div>
          <div style={statBox}>
            <div style={{ fontSize: 22, fontWeight: 800 }}>{wins}</div>
            <div style={{ fontSize: 11, color: '#ffffff88' }}>Won</div>
          </div>
          <div style={statBox}>
            <div style={{ fontSize: 22, fontWeight: 800 }}>{winRate}%</div>
            <div style={{ fontSize: 11, color: '#ffffff88' }}>Win Rate</div>
          </div>
        </div>
        <div style={{ marginTop: 14, textAlign: 'right' }}>
          <a
            href="https://www.ezegames.live/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 11, color: '#00D4FF', textDecoration: 'none' }}
          >
            ezegames.live
          </a>
        </div>
      </div>
    </div>
  );
}
